import React, { Fragment } from 'react';

import cn from 'classnames';

import { THEME } from '@constants/index';
import { Input } from '@element/index'
import { I18n } from '@utils/index';
import { Carousel } from '@widget/airdrop/components/Carousel';
import { getGreeting } from '@widget/airdrop/constants';

import { items } from './config';
import { useSelectBox } from './useSelectBox';

import styles from './index.module.less';

// eslint-disable-next-line react/display-name
export const SelectBox = React.forwardRef((props, ref) => {
  const { updateBox, updateInput, greeting, box } = useSelectBox({ ref })
  return (
    <Fragment>
      <h2 className={cn(styles.title, 'medium')}>{I18n.t('o1ohI2D0')}</h2>
      <div className={styles.content}>

        <Carousel items={items} onChange={updateBox} />
        <div className={styles.div}>
          <p className={styles.label}>{I18n.t('SwdIsdEq')}</p>
          <Input
            placeholder={getGreeting()[box]}
            className={styles.input}
            theme={THEME.DARK}
            value={greeting}
            showClear onChange={updateInput} />
        </div>
      </div>
    </Fragment>
  );
})
